import { darken, lighten, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  priceClassRow: {
    display: 'grid',
    gridTemplateColumns: '4.121fr 1.299fr repeat(14,1fr)',
    height: 40,
    alignItems: 'center',
    backgroundColor:
      theme.palette.type === 'light'
        ? lighten(theme.palette.secondary.light, 0.8)
        : darken(theme.palette.secondary.light, 0.8)
  },
  priceClassRowMonth: {
    gridTemplateColumns: '9.122fr 2.878fr repeat(31,1fr)'
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%'
  },
  rowName: {
    marginLeft: 68,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 15,
    color: theme.palette.secondary.dark
  }
}))

export default useStyles
